import { __awaiter, __decorate } from "tslib";
import { assign } from "@pnp/common";
import { body } from "@pnp/odata";
import { _GraphQueryableCollection, graphInvokableFactory } from "../graphqueryable.js";
import { defaultPath } from "../decorators.js";
import { graphPost } from "../operations.js";
/**
 * Invitations
 */
let _Invitations = class _Invitations extends _GraphQueryableCollection {
    /**
     * Create a new Invitation via invitation manager.
     *
     * @param invitedUserEmailAddress The email address of the user being invited.
     * @param inviteRedirectUrl The URL user should be redirected to once the invitation is redeemed.
     * @param additionalProperties A plain object collection of additional properties you want to set in the invitation
     */
    create(invitedUserEmailAddress, inviteRedirectUrl, additionalProperties = {}) {
        return __awaiter(this, void 0, void 0, function* () {
            const postBody = assign({ inviteRedirectUrl, invitedUserEmailAddress }, additionalProperties);
            const data = yield graphPost(this, body(postBody));
            return { data };
        });
    }
};
_Invitations = __decorate([
    defaultPath("invitations")
], _Invitations);
export { _Invitations };
export const Invitations = graphInvokableFactory(_Invitations);
//# sourceMappingURL=types.js.map